import { render } from "./PanelAvisosDetalle.vue?vue&type=template&id=4ab124fd"
import script from "./PanelAvisosDetalle.vue?vue&type=script&lang=js"
export * from "./PanelAvisosDetalle.vue?vue&type=script&lang=js"
script.render = render

export default script